import Vue from "vue";
import Vuex from "vuex";


import layout from "./module/layout";
import facility from "./module/facility";
import lock from "./module/lock";
import app from "./module/app";
import getters from './getters'


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    layout,
    facility,
    lock,
    app,
  },
  getters
});

export default store;
